import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

const TOKEN_KEY = "ec_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setToken(null);
    }
    return Promise.reject(err);
  }
);

export const unwrap = (resp) => resp?.data?.data ?? resp?.data;

// ---- Cleaner marketplace auth (separate token from admin) -------------------
const CLEANER_TOKEN_KEY = "ec_cleaner_token";
export const getCleanerToken = () => localStorage.getItem(CLEANER_TOKEN_KEY);
export const setCleanerToken = (token) => {
  if (token) localStorage.setItem(CLEANER_TOKEN_KEY, token);
  else localStorage.removeItem(CLEANER_TOKEN_KEY);
};

export const cleanerApi = axios.create({ baseURL: API_BASE, timeout: 30000 });
cleanerApi.interceptors.request.use((config) => {
  const token = getCleanerToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
cleanerApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) setCleanerToken(null);
    if (
      err?.response?.status === 403 &&
      err?.response?.data?.detail?.code === "must_change_password" &&
      typeof window !== "undefined" &&
      window.location.pathname !== "/cleaner/change-password"
    ) {
      window.location.href = "/cleaner/change-password";
    }
    return Promise.reject(err);
  }
);
